/**
 * @name hasFocus
 *
 * @description Checks if the given element is focused
 *
 * @example
 * import { hasFocus } from '@workbench/core';
 *
 * hasFocus(myElementReference); // true
 */
export const hasFocus = (element: HTMLElement): boolean => {
  return (element.getRootNode() as Document | ShadowRoot).activeElement === element;
};
